import { API } from '#app/lib/api/api'
import { localStorageProxy } from '#app/lib/local_storage'
import { info, logError } from '#app/lib/loggers'
import preq from '#app/lib/preq'

export async function requestLogout (redirect: string) {
  try {
    await preq.post(API.auth.logout)
    // Clearing localstorage
    localStorageProxy.clear()
    info('You have been successfully logged out')
    // Default to redirecting home
    window.location.href = redirect || '/'
  } catch (err) {
    logError(err, 'logout error')
  }
}
